module.exports = __webpack_public_path__ + "img/ico-contatore.8db10200.svg";